<template>
	<div ref="inModal" class="in-modal">
		<Input type="text" v-model="data[keys.title]" search readonly :disabled="disabled" @on-focus="show"></Input>
		<Modal class="ivu-in-modal" v-model="modalShow" :closable="false">
			<div slot="header" class="ivu-select ivu-select-multiple ivu-select-default ivu-select-selection">
				<div class="ivu-tag ivu-tag-checked" v-for="item in selectedData">
					<span class="ivu-tag-text">{{ item[keys.title] }}</span>
					<Icon type="ios-close" @click="delSelect(item)"></Icon>
				</div>
				<input type="text" class="ivu-select-input" v-model="para" @change="getData()" />
			</div>
			<Table ref="inTable" :highlight-row="!multiple" :columns="columns" :data="tableData" size="small" border :loading="loading" @on-current-change="currentRow" @on-select-cancel="unSelect" @on-select="onSelect" @on-select-all="allSelect" @on-select-all-cancel="outSelect"></Table>
			<Page size="small" :total="pageTotal" :current="pageNum" :page-size="numPerPage" show-total @on-change="(p)=>{pageNum=p;getData()}" />
			<div slot="footer">
				<Button type="text" size="small" @click="close">取　消</Button>
				<Button type="primary" size="small" @click="submit">　确　认　</Button>				
			</div>
		</Modal>		
	</div>
</template>
<script>
export default {
	name: 'in-modal',
	props: {//父级传递数据
		data:{//默认所选值,此对象键名需包含keys的值
			type: Object,
            default:() => ({title:'',id:''}) 
		},
		keys:{//列表选择数据键值,配合Table数据使用:id=>定义主键,title=>定义显示数据
			type: Object,
            default:() => ({title:'title',id:'id'}) 
		},
		cols:{//必填,定义Table列头与数据显示
			type: Array,
            default:() => ([]) 
		},
		url:{//必填,列表数据地址
			type: String,
			default: ''
		},
		disabled:{//是否禁用
			type: Boolean,
            default: false
		},
		multiple:{//是否多选
			type: Boolean,
            default: false
		},
		query:{//
			type: Object,
            default:() => ({}) 
		}
	},
	data () {
		return {
			modalShow:false,//定义弹出列表开关
			selectedData:[],//已选择数据列表
			columns:[],//列头数据
			tableData:[],//列表数据
			pageTotal:0,//分页,列表数据总数
			pageNum:1,//分页,当前页数
			numPerPage:10,//分页,每页显示条数
			para:'',//检索查询
			loading:false
		}
	},
	mounted(){
		
	},
	methods: {
		show(e){//弹出选择带回Modal
			let el = e.target;
			this.selectedData = [];
			this.loadSelect(this.data);
			this.columns=this.cols;
			if(this.multiple&&this.columns.length&&!this.columns[0].type){
				this.columns.unshift({type: 'selection',width:60,align: 'center'});
			}
			this.getData();
			el.blur();
			this.modalShow=true;
		},
		close(){//关闭Modal
			this.modalShow=false
		},
		submit(){//已选数据列表拆分重组——返还选择数据对象
			const arr = this.selectedData;
			const obj = this.data;
			var json = {};
			for(var key in obj){
				var a = [];
				for(var i=0;i<arr.length;i++){
					a.push(arr[i][key]);
				}
				json[key]=a.join();
			}
			this.$emit('callback',json);
			this.modalShow=false
		},
		getIndex(id,arr){
			for(var i=0;i<arr.length;i++){
				if(arr[i][this.keys.id]==id) return i;
			}
			return false;
		},
		loadSelect(obj){//加载已选数据			
			if(obj[this.keys.id]&&obj[this.keys.id]!=''){
				const idArr = obj[this.keys.id].split(",");
				const nmArr = obj[this.keys.title].split(",");
				for(var i=0;i<idArr.length;i++){
					if(this.getIndex(idArr[i],this.selectedData)!==false)continue;
					var json = {};
					json[this.keys.id]=idArr[i];json[this.keys.title]=nmArr[i];
					this.selectedData.push(json)
				}
				console.log(this.selectedData)
			}
		},
		delSelect(obj){//删除已选数据
			if(this.multiple){
				let n = this.getIndex(obj[this.keys.id],this.selectedData);
				if(n===false) return;
				this.selectedData.splice(n,1);
				for(var i=0;i<this.tableData.length;i++){
					if(this.tableData[i][this.keys.id]==obj[this.keys.id]){
						delete this.tableData[i]._checked;
						this.tableData.splice(i,1,this.tableData[i])
						return;
					}
				}
			}else{
				this.selectedData=[];
				this.$refs.inTable.clearCurrentRow();
			}			
		},
		onSelect (selection,row){//多选选中事件	
			if(this.getIndex(row[this.keys.id],this.selectedData)===false){
				var json={};const obj=this.data;
				for(var key in obj){
					json[key]=row[key];
				}
				this.selectedData.push(json)
			}			
		},
		unSelect (selection,row){//多选取消事件		
			let i = this.getIndex(row[this.keys.id],this.selectedData);
			if(i===false) return;
			this.selectedData.splice(i,1);
		},
		allSelect (selection){//全选选中事件			
			for(var i=0;i<selection.length;i++){
				if(this.getIndex(selection[i][this.keys.id],this.selectedData)===false){
					var json={};const obj=this.data;
					for(var key in obj){
						json[key]=selection[i][key];
					}
					this.selectedData.push(json)					
				}				
			}
		},
		outSelect(){//全选取消事件
			const arr = this.tableData;
			for(var i=0;i<arr.length;i++){
				let n = this.getIndex(arr[i][this.keys.id],this.selectedData);
				if(n===false) continue;
				this.selectedData.splice(n,1);
			}
		},
		currentRow(row){//单选选中事件
			if(row==null) return;
			var json={};const obj=this.data;
			for(var key in obj){
				json[key]=row[key];
			}
			this.selectedData=[json];
		},
		getData(){//加载列表数据
			if(this.url=='') return;
			this.loading=true;
			var query = Object.assign({},{globalprop:this.para},this.query,{pageNum:this.pageNum,numPerPage:this.numPerPage});
			this.$ajax.post(this.url,query).then(data => {
				if(data.status==this.$ajax.HTTP_S){
					this.tableData=data.result.enArray;
					this.pageTotal=data.result.totalCount;
					if(this.tableData.length&&this.selectedData.length) this.setData();					
				}
				this.loading=false;
			});	
		},
		setData(){//设置已选数据回显
			const s = this.selectedData;
			for(var i=0;i<s.length;i++){
				var id=s[i][this.keys.id];
				for(var j=0;j<this.tableData.length;j++){
					if(this.tableData[j][this.keys.id]==id){
						if(this.multiple){
							this.tableData[j] = Object.assign({},this.tableData[j],{_checked: true});
						}else{
							this.tableData[j] = Object.assign({},this.tableData[j],{_highlight: true});
							return;
						}
					}
				}
			}
		}
	}
}
</script>






// WEBPACK FOOTER //
// src/components/inc/modal/in-modal.vue